export const environment = {
  API_URL: 'https://padevapi.partanalytics.com/api/v1',
  API_URL_V2: 'https://padevapi.partanalytics.com/api/v2',

  // API_URL: 'https://api-next.partanalytics.com/api/v1',
  // API_URL: 'http://ec2-3-227-23-49.compute-1.amazonaws.com:3600/api/v1',
  production: true,
  authSecretKey: "fAhichanoch1d!tlfotr",
  storageEncryptDecryptKey: "43ea6df2-314a-42ee-ab82-9f8c20e5c736",
  API_URL_WF: 'https://padevapi.partanalytics.com/api/v1/workflow',
  redirectUri: "https://padevadmin.partanalytics.com",
  SSOClientId: "57bbd726-bfd3-4a35-a7a9-bc722ab21fa8",
  SSOTenantId: "2659483d-ae03-4acb-a64b-42478a67b671",
  SSOScopes: {
    "scopes": ["api://124e8097-53fd-4f63-94e1-7a084498fdb3/.default"]
  },
  appRedirectUri: "https://padev.partanalytics.com/auth/login",
  bucketURL: 'https://pa-web-file-uploads-dev.s3.amazonaws.com',
  cbomConfigurationCompanyIds: ['5c096351-c8fe-4e00-b5cf-f9971edd2440'],
  expiryTokenTime: 3,
  issuer: "https://altium.okta.com",
  clientId: "0oa19b7jpydG9KJGg1t8"
};

